/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import Layout from '../../../../common/components/layout/Layout';
import Header from '../../../../common/components/layout/Header';
import ListPositions from '../../../../common/components/sections/ListPositions';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../../../common/loading/Loading';
import { attributesBySport } from '../../../../common/data/attributes';

import { getRankingBysportPaginated } from '../../../../modules/sport/actions/reducerListRanking';
import { getIdSports } from '../../../../common/data/sports';
import FilterRanking from '../../../../common/components/modules/sports/FilterRanking';
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const Positions = (): JSX.Element => {
    const attribute = attributesBySport('defy');
    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const query = useQuery();
    //const format = query.get('format');
    const region = query.get('region');
    const commune = query.get('commune');
    const limit = query.get('limit') || 50;
    const page = query.get('page') || 1;
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const sportId = query.get('sportId') || getIdSports(sport);
    const season = query.get('season');
    const month = query.get('month');
    const days = query.get('days');
    const filter = {
        months: [],
        sport,
        sportId,
        //format,
        region,
        commune,
        limit,
        page,
        communes: [],
        month,
        season,
        days,
    };
    /*List Defys */
    const selectListRanking = (state: any) => state.listRanking;
    const rankings = useSelector(selectListRanking);

    useEffect(() => {
        if (sport && region) {
            // console.log('en el index **** ', { filter });
            const query = {
                sport: filter.sport,
                sportId: filter.sportId,
                regionId: filter.region,
                communes: commune,
                limit: filter.limit,
                page: filter.page,
                ...(filter.month !== '' && filter.month !== null
                    ? { month: filter.month }
                    : filter.days !== '' && filter.days !== null
                    ? { days: filter.days }
                    : filter.season !== '' && filter.season !== null && { season: filter.season }),
            };
            // console.log('en el index **** ', { query });
            dispatch(getRankingBysportPaginated(query));
        }
    }, [sport, region, page]);

    return (
        <Layout navProps={{ title: 'Desafíar | Supermatch', description: 'Desafíar Supermatch' }}>
            <div className="bg-gradient-to-r from-[#72607e] via-[#486a81] to-[#1e7f84]">
                <Header />
                <div className="mt-20">
                    {attribute ? (
                        // <FilterPositions
                        //     filter={filter}
                        //     setFilter={setFilter}
                        //     monthList={monthList()}
                        //     handlerDefy={handlerDefy}
                        // />
                        <FilterRanking />
                    ) : (
                        ''
                    )}
                </div>
                {rankings.isLoading ? (
                    <Loading />
                ) : rankings.error && rankings.error.code ? (
                    <div className="flex items-center justify-center lg:h-96 mb:h-96 ">
                        <p className="text-2xl text-sm-blue-primary">
                            El Servicio no está Disponible en estos momentos
                        </p>
                    </div>
                ) : (
                    <>
                        <ListPositions
                            attribute={attribute}
                            filter={filter}
                            origin={'defy-team'}
                            sport={sport}
                            rankings={rankings}
                        />
                    </>
                )}
            </div>
        </Layout>
    );
};

export default Positions;
